import { Link } from "react-router-dom";

const stats = [
  { value: "10+", label: "精选恋爱作品" },
  { value: "6", label: "热门剧情栏目" },
  { value: "500万+", label: "累计心动读者" },
  { value: "99%", label: "脸红剧情浓度" },
];

const reasons = [
  {
    icon: "ri-heart-3-fill",
    title: "只选感情线细腻的",
    desc: "我们筛选标准只有一个——剧情走心、升温缓慢、心动密集，拒绝无脑注水。",
  },
  {
    icon: "ri-vip-diamond-fill",
    title: "人工编辑安利",
    desc: "每一部编辑精选都由桃桃编辑部亲自读过，带着真实上头感受推荐给你。",
  },
  {
    icon: "ri-flashlight-fill",
    title: "更新快不迷路",
    desc: "热门连载持续更新，最新章节实时上架，配合订阅提醒追更更省心。",
  },
];

export default function AboutContact() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 py-14 md:py-20">
      <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-secondary-100 via-background-100 to-background-50">
        <div className="grid grid-cols-1 gap-10 p-6 md:grid-cols-2 md:p-12">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-secondary-700">
              <i className="ri-heart-pulse-fill"></i>
              关于桃桃漫画网
            </span>
            <h2 className="mt-3 font-display text-3xl leading-tight text-foreground-950 md:text-4xl">
              为喜欢慢热感情线的你，准备一场心动马拉松
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
              桃桃漫画网聚集了一批擅长刻画暧昧桥段与恋爱拉扯的优质作品。我们不追求爆点轰炸，而是用细腻的情感发展和密集的心动瞬间，
              让每一个喜欢慢慢升温的读者，都能在这里找到对味的故事、脸红的时刻，以及那份藏在拉扯里的心动。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl bg-background-50/80 p-4">
                  <p className="font-display text-2xl text-secondary-600 md:text-3xl">{s.value}</p>
                  <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              了解我们的故事
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-col gap-4">
            {reasons.map((r) => (
              <div key={r.title} className="flex items-start gap-4 rounded-2xl bg-background-50/80 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                  <i className={`${r.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="text-[15px] font-bold text-foreground-950">{r.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
                </div>
              </div>
            ))}
            <div className="rounded-2xl border border-secondary-200 bg-secondary-50/70 p-5">
              <h3 className="text-[15px] font-bold text-foreground-950">有任何问题想聊？</h3>
              <p className="mt-1 text-sm text-foreground-600">
                关于作品推荐、更新反馈或任何建议，欢迎通过页面底部的订阅或联系方式与我们联系。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}